import React from "react";
import { AlertTriangle } from "lucide-react";

export default function AllowanceBar({ allowance, reset, size = "md" }) {
  if (!allowance) return null;
  const { total, used, remaining } = allowance;
  const pct = total ? Math.min(100, Math.round((used / total) * 100)) : 0;
  const color = pct >= 100 ? "#D0526B" : pct >= 80 ? "#B8892B" : "#93C020";
  const big = size === "lg";
  return (
    <div data-testid="allowance-bar">
      <div className="flex items-baseline justify-between mb-1.5">
        <span className={`font-bold text-ink ${big ? "text-lg" : "text-sm"}`}>{used} / {total} <span className="text-ink-3 font-medium">managed actions used</span></span>
        <span className="text-sm font-semibold" style={{ color }}>{remaining} remaining</span>
      </div>
      <div className={`w-full rounded-full overflow-hidden ${big ? "h-2.5" : "h-2"}`} style={{ background: "#EDEEE9" }}>
        <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, background: color }} />
      </div>
      {pct >= 100 ? (
        <div className="flex items-center gap-1.5 mt-2 text-xs font-semibold" style={{ color: "#D0526B" }}>
          <AlertTriangle size={13} strokeWidth={2} /> Managed allowance reached — approval required for additional activity.
        </div>
      ) : pct >= 80 ? (
        <div className="flex items-center gap-1.5 mt-2 text-xs font-semibold" style={{ color: "#B8892B" }}>
          <AlertTriangle size={13} strokeWidth={2} /> {pct}% of monthly allowance used.
        </div>
      ) : reset ? (
        <div className="mt-2 text-xs text-ink-3">Next reset: {reset}</div>
      ) : null}
    </div>
  );
}
